var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('el-empty',{attrs:{"description":"无权限使用该产品"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }